"use client";
import ExpiredPage from "@/components/page/expired-page";
import { redirect } from "next/navigation";
import { useSearchParams } from "next/navigation";
import MaintenancePage from "@/components/page/maintenance-page";

export default function BusinessVerificationWrapper({
    children,
    businessData,
    maMode,
}: {
    children: React.ReactNode;
    businessData: { businessExp: string; activeDomain: string; domain: string };
    maMode: boolean;
}) {
    const searchParams = useSearchParams();
    const currentPath = `${searchParams.toString() ? "?" + searchParams.toString() : ""}`;
    const { businessExp, activeDomain, domain } = businessData;

    // Verify maintenance mode
    if (maMode) {
        return <MaintenancePage />;
    }

    // Verify business expiration
    if (new Date(businessExp) < new Date() && businessExp) {
        return <ExpiredPage />;
    }

    // Verify business domain
    if (domain && domain !== activeDomain) {
        redirect(`https://${activeDomain}${currentPath}`);
    }

    return <>{children}</>;
}
